<template>
    <div v-if="timer.isShowTimer">
        <p id="serial_timer"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
            <span>{{lbl.gift_serial.expire_in}}</span>
            <span id="serial_timeleft"
                :class="{'serial-expired': timer.isExpired}">
                {{displayTime}}
            </span>
        </p>
    </div>
</template>
<script>
import TimerHelper from '@/helper/TimerHelper.js';
export default {
    name: 'GiftTimer',
    props: {
        lbl: Object,

        campaign: Object,
        theme: String,
        busGift: Object
    },
    data: function () {
        return {
            timer: new TimerHelper(),
            displayTime: "",
            day: null,
            hour: null,
            minute: null,
            second: null
        }
    },
    created: function () {
        this.initial();
    },
    methods: {
        //initial
        initial: function () {
            if (this.campaign.serial == 'XXXXXXX') return;

            if (this.timer.interval)
                this.timer.stopTimer();

            this.timer.initialTimer(this.campaign.expireIn, null, true, true);

            if (this.timer.isShowTimer) {
                this.timer.runTimer((display) => {
                    this.displayTime = display.split(":");
                    this.day = this.displayTime[0];
                    this.hour = this.displayTime[1];
                    this.minute = this.displayTime[2];
                    this.second = this.displayTime[3];
                    if (this.day > 0) {
                        this.displayTime = `${this.day} ${this.lbl.gift_serial.day} ${this.hour}:${this.minute}`
                    } else if (this.hour > 0) {
                        this.displayTime = `${this.hour}:${this.minute}`
                    } else if (this.minute > 0) {
                        this.displayTime = `${this.minute}:${this.second}`
                    } else {
                        this.displayTime = `${this.second}`
                    }
                });
            } else {
                if (this.campaign.expireIn
                    && this.campaign.expireIn <= 0) {
                    this.$nextTick(() => {
                        this.serialExpired();
                    });
                }
            }
        },
        //method
        serialExpired: function () {
            this.busGift.$emit('serial-expired', {});
        }
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
#serial_timer {
    width: 100%;
    font-size: 14px;
    font-weight: 700;
    color: $color-gray;
    text-align: center;
    margin-bottom: 0;

    #serial_timeleft {
        color: $color-red;
    }
}
</style>
